<template>
	<v-card style="min-width: 65%; max-width: 80%" elevation="5">
		<v-card-text>
			<v-container fluid>
				<v-row align="center" justify="center">
					<v-col cols="4" v-for="feature in features" v-bind:key="feature.name">
						<v-card class="d-flex align-center justify-center px-7 py-5" style="height: 180px !important;" outlined>
							<div>
								<div class="d-flex align-center justify-center">
									<h3 class="text-center">{{ feature.name }}</h3>
									<v-chip :color="getStatusColor(feature.status)" text-color="white" class="ml-2" small>
										<p style="font-size: 13px" class="mb-0">{{ feature.status }}</p>
									</v-chip>
								</div>
								<p class="text-center mb-0 mt-3">{{ feature.description }}</p>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
  name: "PriorityFeaturesList",
  props: {
    features: Array,
  },
	methods: {
    getStatusColor(status) {
      switch (status) {
        case 'Thinking':
          return '#111111';
        case 'Planning':
          return '#d06600';
        case 'Developing':
          return '#00a553';
        case 'Testing':
          return '#00186e';
      }
    },
  }
};
</script>

<style>
</style>